<!-- 总费用明细 -->
<template>
  <div class="price-total-view">
    <PriceView :data="priceTotalFields" />
  </div>
</template>

<script>
// 订单价格展示
import PriceView from '@@/components/priceView/index'

export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    type: {
      type: String,
      validator: function (value) {
        return ['PCB', 'FPC', 'SMT', 'PCB_SMT', 'FPC_SMT', 'SMT_PCB', 'SMT_FPC'].includes(value)
      }
    },
    isFpcNeedAudit: {
      type: Boolean,
      default: false
    }
  },
  components: {
    PriceView
  },
  computed: {
    showFields() {
      const type = this.type
      return {
        pcb_amount: { label: 'PCB制作费', show: type !== 'SMT' },
        smt_amount: { label: 'SMT加工费', show: type.includes('SMT') },
        insurance_amount: { label: 'PCB品质服务费', show: false },
        freight_amount: { label: '运费', show: true },
        tax_amount: { label: '税费', show: true },
        discount_amount: { label: '活动折扣', show: true }
      }
    },
    priceTotalFields() {
      const { data, showFields, isFpcNeedAudit, type } = this
      // 活动提示
      const { pcb = [], smt = [] } = data.activity || {}
      const tips = [...pcb, ...smt].map(item => `${item.title}：${item.amount}`).join(`\n`)

      if (isFpcNeedAudit && type === 'FPC') {
        return ['pcb_amount', 'freight_amount', 'tax_amount']
          .map(key => ({ label: showFields[key].label, value: '----', hideUnit: true }))
      }
      
      return Object.keys(showFields)
        .filter(key => showFields[key].show || data[key] && data[key] > 0)
        .map(key => {
          const label = showFields[key].label
          // PCB制作费
          if (key === 'pcb_amount' && isFpcNeedAudit && ['FPC_SMT', 'SMT_FPC'].includes(type)) {
            return { label, value: '以审核为准', hideUnit: true, color: '#E6A23C' }
          }
          // 活动折扣
          if (key === 'discount_amount') {
            return { label, value:  (+data[key] || 0).toFixed(2), symbol: '-', tips, color: '#F65001' }
          }
          return { label, value:  (+data[key] || 0).toFixed(2) }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.price-total-view {
  margin-top: 12px;
}
</style>